import { defineStore } from "pinia"
import { useRoute } from "vue-router"
import router from "../router"
import FeedService from "../services/FeedService.js"

export const useFilteredFeedStore = defineStore("filteredFeed", {
	state: () => ({
		endpoint: document.querySelector("#app").dataset.endpoint || "post",
		items: [],
		taxonomy: document.querySelector("#app").dataset.taxonomy || "categories",
		featuredTitle: "",
		featuredItems: [],
		isLoading: true,
		filters: {},
		filterLabels: [],
		filterMode: "single", // single/multi taxonomy option
		isFiltered: false,
		isToggled: false,

		// Only for main feed
		page: null,
		maxNumPages: null,
		foundPosts: null,
	}),
	actions: {
		async initState() {
			const route = useRoute()
			if (route.query.length) {
				this.isFiltered = true
			}
			return route.query
		},
		setState() {
			router.push({ name: "home", query: this.filters })
		},
		updateFilters({ taxonomy, term, name }) {
			if (!this.filters[taxonomy]) {
				this.filters = {
					...this.filters,
					[taxonomy]: this.filterMode == "single" ? term : [term],
				}
			} else {
				if (this.filterMode == "single") {
					if (this.filters[taxonomy] == term || term === null ) {
						delete this.filters[taxonomy]
					} else {
						this.filters[taxonomy] = term
					}
				} else {
					if (typeof this.filters[taxonomy] === "string") {
						this.filters[taxonomy] = [this.filters[taxonomy]]
					}
					const index = this.filters[taxonomy].indexOf(term)
					if (index === -1) {
						this.filters[taxonomy].push(term)
					} else {
						this.filters[taxonomy].splice(index, 1)
						if (this.filters[taxonomy].length === 0) {
							delete this.filters[taxonomy]
						}
					}
				}
			}

			delete this.filters._p
			this.setState()
		},
		removeDateFilter() {
			// Just for removing date filter
			// Needs to be separate as it's only a single choice
			// Similar to a radio field rather than a checkbox
			delete this.filters.date
			this.setState()
		},
		async fetchItems() {
			this.isLoading = true

			try {
				const response = await FeedService.getFeed(this.endpoint, {
					params: this.filters,
				})
				
				setTimeout(()=>{
					this.items = response.data.items || []
					this.page = response.data._p
					this.foundPosts = response.data.found_posts
					this.maxNumPages = response.data.max_num_pages
					this.isFiltered = Object.keys(this.filters).length > 0
					this.filterLabels = response.data.labels
					
					this.isLoading = false
				},666)

				// console.log( this.foundPosts )
			} catch (error) {
				console.log(error)
			}
		},
		async fetchFeatured() {
			try {
				const response = await FeedService.getFeatured({
					params: { post_type: this.endpoint },
				})
				this.featuredItems = response.data.items
				this.featuredTitle = response.data.title
			} catch (error) {
				console.log(error)
			}
		},
		clearFilters() {
			this.filters = {}
			this.filterLabels = []
			this.setState()
		},
		resetApp() {
			this.clearFilters()
			this.isFiltered = false
			this.fetchItems()
		},
		navigateNext() {
			if (this.page < this.maxNumPages) {
				this.page++
			}
			this.filters._p = this.page
			this.setState()
		},
		navigatePrev() {
			if( this.page > 1 ){
				this.page--
				this.filters._p = this.page
			}

			if( this.page === 1 ){
				delete this.filters._p
			}
			
			this.setState()
		},
		inFilters(term, taxonomy) {
			const filters = this.filters
			return filters[taxonomy] && filters[taxonomy].includes(term)
		},
	},
	getters: {
		noFilters: (state) => Object.keys(state.filters).length === 0,
		hasSingleTaxonomy: (state) => {
			return state.endpoint === "post"
		},
	},
})
